import { Box, Typography } from "@mui/material";
import { ArrowDown2Icon, ArrowUp2Icon } from "~/assets/icons";


interface DashboardStatsProps {
    icon: React.ReactNode;
    value: string | number;
    label: string;
    percentage: string;
    chart?: React.ReactNode;
  }
  
  const DashboardStats: React.FC<DashboardStatsProps> = ({
    icon,
    value,
    label,
    percentage,
    chart
  }) => {
    const isNegative = percentage.startsWith('-');
  
    return (
      <Box className="bg-[#071427] rounded-lg p-4 shadow-sm">
        <Box className="flex items-end justify-between">
          <Box className="flex flex-col ">
            <Box className="text-gray-600 mb-[20px] w-[48px] h-[48px] flex items-center justify-center bg-[#D8E8FF1A] rounded-[100%] ">
              {icon}
            </Box>
            <Box className="text-gray-500 text-sm !text-[14px] mb-[8px]">{label}</Box>
            <Box className="flex items-center gap-2">
              <Box className="text-[24px] font-bold text-white">{value}</Box>
              {
                percentage &&  <Box className={`text-sm flex items-center gap-1 ${isNegative ? 'text-[#2DB3FC]' : 'text-[#48CFA9]'}`}>
                    {isNegative ? <ArrowDown2Icon className="w-[12px] h-[12px]" /> : <ArrowUp2Icon className="w-[12px] h-[12px]" />}
                    <Typography>{percentage.slice(1)}</Typography>
                </Box>
              }
             
            </Box>
              {/* <Box className="text-gray-500 uppercase text-sm">{label}</Box> */}
          </Box>
          
          <Box className="flex flex-col items-end mb-2">
          
            {chart && (
              <Box className="w-[140px] h-[80px]">
                {chart}
              </Box>
            )}
                 
          </Box>
        </Box>
        
      </Box>
    );
  };
  
  export default DashboardStats;